import * as yup from 'yup';

export const updateProfileRequest =  yup.object().shape({
    firstname: yup.string().required(),
    lastname: yup.string().required(),
    othername: yup.string().nullable(),
    education: yup.string().required(),
    occupation: yup.string().notRequired(),
    empoymentStatus: yup.string(),
    averageIncome: yup.string().required(),
    country: yup.string().required(),
    state: yup.string().notRequired(),
    religion: yup.string().required(),
});


export const updateSettingsRequest = yup.object().shape({
    notifyType: yup.string().required(),
    language: yup.string().required(),
})